module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('span', {
    staticClass: "text-center text-info"
  }, [_vm._v(_vm._s(_vm.percent) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "progress progress-xs m-t-sm bg-white"
  }, [_c('div', {
    staticClass: "progress-bar bg-info",
    style: ('width:' + _vm.percent + '%;')
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20be3d3a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/documentos/components/ImportProgress.vue
// module id = 1547
// module chunks = 17